import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { Header, Icon, Image, Menu, Segment, Sidebar, Input, Button, Table } from 'semantic-ui-react'
import { Container } from "reactstrap";

// import {Form} from "semantic-ui-react";

class ApplicationSettings extends Component {
  static defaultProps = {
    locations: ["Chama", "Springer", "Questa", "Lordsburg", "Mora", "Angelfire"]

  };

  constructor(props) {
    super(props);
    this.state = {
      unassignedLocations: this.props.locations,
      search: false,
      searchTerm: "",
      userDetails: {
        active: true,
        admin: true,
        branches: [],
        dateOfBirth: "2019-10-27T19:22:12.633Z",
        emailAddress: "",
        firstName: "",
        gender: "M",
        lastName: "",
        newUser: true,
        orgId: "" + localStorage.orgID,
        password: "",
        phoneNumber: 0,
        roles: []
      },
      errors: {},
      selectedValue: ""
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.checkbox = this.checkbox.bind(this);
    this.activeToggle = this.activeToggle.bind(this);
  }

  select = option => {
    let selection = this.state.userDetails.branches;
    let unassigned = this.state.unassignedLocations;
    selection.unshift(option);
    unassigned.splice(unassigned.indexOf(option), 1);
    this.setState({
      userDetails: {
        ...this.state.userDetails,
        branches: selection
      },
      unassignedLocations: unassigned
    });
  };

  unselect = option => {
    let selection = this.state.userDetails.branches;
    let unassigned = this.state.unassignedLocations;
    selection.splice(selection.indexOf(option), 1);
    unassigned.unshift(option);
    this.setState({
      userDetails: {
        ...this.state.userDetails,
        branches: selection
      },
      unassignedLocations: unassigned
    });
  };

  onChange = e => {
    if (e.target.name === "roles") {
      this.setState({
        userDetails: {
          ...this.state.userDetails,
          [e.target.name]: this.state.userDetails.roles.concat(e.target.value)
        }
      });
    } else {
      this.setState({
        userDetails: {
          ...this.state.userDetails,
          [e.target.name]: e.target.value
        }
      });
    }
  };
  onSearch = e => {
    e.preventDefault();
    this.setState({ search: true });
    this.setState({ searchTerm: e.target.value.toLowerCase() }, () => {
      let locations;
      locations = _.filter(this.props.locations, location =>
        location.toLowerCase().includes(this.state.searchTerm)
      );
      this.setState({ unassignedLocations: locations });
    });
  };

  checkbox = () => {
    const userDetails = this.state.userDetails;
    userDetails.admin = !userDetails.admin;
    this.setState({
      userDetails: userDetails
    });
  };

  activeToggle = () => {
    const userDetails = this.state.userDetails;
    userDetails.active = !userDetails.active;
    this.setState({
      userDetails: userDetails
    });
  };

  onSubmit = e => {
    e.preventDefault();
    let errors = {};

    this.props.createUser(this.state.userDetails, this.props.history);
  };

  render() {


    return (
      <div className="" style={{ paddingTop: "5vh", marginBottom: "5vh" }}>
        <Sidebar.Pushable as={Segment} style={{ height: "80vh" }}>
          <Sidebar
            as={Menu}
            animation='overlay'
            icon='labeled'

            vertical
            visible
            width='thin'
          >
            <Menu.Item as='a'>
              <Icon name='settings' />
              Reject Reasons
            </Menu.Item>

          </Sidebar>

          <Sidebar.Pusher>
            <Segment basic className="" style={{ marginLeft: "10%" }}>
              <Header as='h3'>Predefine Reject Reasons</Header>
              <Input className="block" placeholder='Search...' style={{ width: "50%" }} />
              <Button className="ml-2" content='Add Rejection Reason' style={{ backgroundColor: "#17a2b8", color: "white" }} />
            </Segment>
            <Table striped style={{ marginLeft: "10%", width: "80%" }}>
              {/* <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Added By</Table.HeaderCell>
        <Table.HeaderCell>Reject Reason Text</Table.HeaderCell>
        <Table.HeaderCell>Delete</Table.HeaderCell>
        
      </Table.Row>
    </Table.Header> */}

              <Table.Body>
                <Table.Row>
                  <Table.Cell>Admin Saika</Table.Cell>
                  <Table.Cell>Reject Reason 1</Table.Cell>
                  <Table.Cell><i class="fas fa-minus-circle" style={{ color: "red" }}></i></Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Test Saika</Table.Cell>
                  <Table.Cell>Reject Reason 2</Table.Cell>
                  <Table.Cell><i class="fas fa-minus-circle" style={{ color: "red" }}></i></Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Test Pharma</Table.Cell>
                  <Table.Cell>Reject Reason 3</Table.Cell>
                  <Table.Cell><i class="fas fa-minus-circle" style={{ color: "red" }}></i></Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Bharath Chandra</Table.Cell>
                  <Table.Cell>Reject Reason 4</Table.Cell>
                  <Table.Cell><i class="fas fa-minus-circle" style={{ color: "red" }}></i></Table.Cell>
                </Table.Row>

              </Table.Body>
            </Table>
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    );
  }
}

ApplicationSettings.propTypes = {

  errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default connect(mapStateToProps)(
  withRouter(ApplicationSettings)
);
